import { useEffect, useState } from 'react';

/**
 * A clock that only runs when something is actually live.
 *
 * The Run Ledger shows real elapsed time, so a live stop has to re-render once
 * a second. A ticker that runs unconditionally would keep an idle tab
 * re-rendering the whole thread forever, which on a long conversation is a
 * measurable battery cost for no information.
 */
export function useTicker(active: boolean, intervalMs = 1000): number {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!active) return;
    setNow(Date.now());
    const id = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(id);
  }, [active, intervalMs]);

  return now;
}
